

import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
import { EActionType, EColorState, IAction, IIcon, TText } from "@/components/IBPayment/interface";
import GlobalMixin from "@/mixins/global";
import IBPaymentCardActionCaller from "@/components/IBPayment/mixins/IBPaymentCardActionCaller";
import IBPaymentCardButtonColor from "@/components/IBPayment/mixins/IBPaymentCardButtonColor";
import IBPaymentCardIcon from "@/components/IBPayment/IBPaymentCardIcon.vue";

@Component({
	components: {
		IBPaymentCardIcon
	}
})
export default class IBPaymentCardButton extends Mixins(
	GlobalMixin,
	IBPaymentCardActionCaller,
	IBPaymentCardButtonColor
) implements IAction {

	@Prop({ type: Boolean, default: false })
	readonly disabled!: boolean

	@Prop(String)
	readonly color!: EColorState

	@Prop([ String, Number ])
	readonly text!: TText

	@Prop([ String, Number ])
	readonly subText!: TText

	@Prop(Object)
	readonly prependIcon!: IIcon

	@Prop(Object)
	readonly appendIcon!: IIcon

	@Prop({ type: String, default: 'button' })
	readonly type!: EActionType

	@Prop(Function)
	readonly action!: (() => void) | undefined

	onClick() {
		if (!this.disabled) {
			if (this.action) this.callAction(this.action);
			else this.emitClick();
		}
	}

	@Emit('click')
	emitClick() {}

}

